module.exports = __webpack_public_path__ + "static/media/background_ENG.b0129b20.jpg";